<template>
  <section
    class="mothly-view-calc monthly-split-view edit-appoitntment bg-none table-monthly-view"
    v-if="appointment"
  >
    <div class="boxes-container">
      <div class="event-wrapper">
        <span class="heading-with-edit" v-if="!(editMode && editLevel >= 1)">
          <h3 :class="{ strike: detail.is_cancelled }">
            {{ appointment.title }}
          </h3>

          <span class="header-btn">
          <!-- Video session button -->
          <template v-if="1 == appointment.isVideo && 1 != appointment.isConnect">
            <button
              v-if="
                appointment.clientConnectcode
              "
              class="video-session-button"
              @click="startVideoSessionPortal(appointment.clientConnectcode)"
            >
              Start video session
            </button>
            <button
              v-else-if="
                appointment.secure_video_session_id &&
                  (userRole === 8 || userRole === 11 || userRole === 7)
              "
              class="video-session-button"
              @click="startVideoSession(appointment.id)"
            >
              Start video session
            </button>

            <!-- Video session for portal user -->
            <button
              v-if="
                appointment.connectCode && (userRole === 22 || userRole === 25)
              "
              class="video-session-button"
              @click="startVideoSessionPortal(appointment.connectCode)"
            >
              Start video session
            </button>
          </template>

          <!-- Video session button -->
          <template v-if="1 == appointment.isVideo && 1 == appointment.isConnect">
            <button
              v-if="
                appointment.clientConnectcode
              "
              class="video-session-button"
              @click="startConnectSessionPortal(appointment.clientConnectcode)"
            >
              Start video session
            </button>
            <button
              v-else-if="
                appointment.secure_video_session_id &&
                  (userRole === 8 || userRole === 11 || userRole === 7)
              "
              class="video-session-button"
              @click="startConnectSession(appointment.secure_video_session_id, appointment.hashedPassCode)"
            >
              Start video session
            </button>

            <!-- Video session for portal user -->
            <button
              v-if="
                appointment.connectCode && (userRole === 22 || userRole === 25)
              "
              class="video-session-button"
              @click="startConnectSessionPortal(appointment.connectCode)"
            >
              Start video session
            </button>
          </template>
          </span>
        </span>

        <div
          class="event-subdetails-wrapper"
          v-if="!(editMode && editLevel >= 1)"
        >
          <p class="day-dates">{{ appointment.dateBeautified }}</p>
          <p class="timing">
            From {{ appointment.startTime }} to {{ appointment.endTime }}
          </p>
          <p class="day-repeats">{{ appointment.repeat }}</p>

          <!-- Details -->
          <div class="event-timing-wrapper" v-if="!editMode">
            <ul>
              <li>
                <div class="hours-timing">{{ appointment.timeList[0] }}</div>
                <div></div>
              </li>
              <li>
                <div class="hours-timing">{{ appointment.timeList[1] }}</div>
                <div class="have-event">
                  <span>{{ appointment.title }}</span>
                </div>
              </li>
              <li>
                <div class="hours-timing">{{ appointment.timeList[2] }}</div>
                <div></div>
              </li>
              <li>
                <div class="hours-timing">{{ appointment.timeList[3] }}</div>
                <div></div>
              </li>
            </ul>
          </div>
        </div>
        <div
          class="input-wrapper all-day-wrapper timing-wrapper border-bottom-none pl-0"
          v-if="!editMode"
        >
          <div class="title-wrapper position-relative">
            <span class="ver-center">Notes</span>
          </div>
          <div
            class="content-wrapper position-relative notes-container"
            v-if="appointment.notes !== 'No notes'"
          >
            <div class="notes notes-html" v-html="appointment.notes"></div>
          </div>

          <div class="content-wrapper position-relative notes-container" v-else>
            <div class="notes" v-html="appointment.notes"></div>
          </div>
        </div>

        <!-- Edit -->
        <section-vue
          :show-search="showSearch"
          :hide-search="hideSearch"
          :edit-level="editLevel"
          :first-click="firstClick"
          :set-edit-level="setEditLevel"
          :set-first-click="setFirstClick"
          :add-option-selected="addOptionSelected"
          :popup="popup"
          v-else
        />
        <div class="loader-container-appointmentpage" v-show="spinner">
          <loader-vue />
        </div>
      </div>
    </div>
  </section>
</template>

<script>
import LoaderVue from "../common/Loader.vue";
import SectionVue from "../AddAppointment/Section";
import { mapGetters, mapActions, mapMutations } from "vuex";
import { permissionMixin } from "../../../mixins/permissionMixin";
import { dateAndTimeMixin } from "../../../mixins/dateAndTimeMixin.js";
import { nameMixin } from "../../../mixins/nameMixin.js";
import { ERROR_MESSSAGE } from "../../../store/config";

export default {
  mixins: [permissionMixin, dateAndTimeMixin, nameMixin],
  props: {
    editMode: Boolean,
    editLevel: Number,
    firstClick: Boolean,
    setEditLevel: Function,
    setFirstClick: Function,
    popup: Function,
    displaySearch: Boolean,
    showSearch: Function,
    hideSearch: Function,
    addOptionSelected: Function
  },
  data() {
    return {
      showPopup: false
    };
  },
  computed: {
    ...mapGetters({
      details: "getDetail",
      getQueriedId: "getQueriedId",
      userRole: "getUserRole",
      selectedProviderID: "getSelectedProviderID",
      spinner: "getLoadingAppointmentDetails",
      baseSecureVideoUrl: "getBaseSecureVideoUrl" // The base secure video url
    }),
    detail() {
      const id = !isNaN(this.$route.params.id)
        ? parseInt(this.$route.params.id)
        : false;
      return id && id in this.details ? this.details[id] : false;
    },
    /**
     * Different values required from current appointment
     */
    appointment() {
      if (this.detail) {
        // Format title
        let title = "";
        if (this.userRole === 25 && +this.detail["otherevent_type"] === 1) {
          title = this.formatName(
            this.detail["firstName"],
            this.detail["middleName"],
            this.detail["lastName"],
            this.detail["namePrefix"],
            this.detail["nameSuffix"]
          );
        } else {
          title =
            this.detail["otherevent_id"] !== 0
              ? this.detail["otherevent_name"]
              : this.detail["app_oth_event"] !== ""
              ? this.detail["app_oth_event"]
              : this.formatName(
                  this.detail["firstName"],
                  this.detail["middleName"],
                  this.detail["lastName"],
                  this.detail["namePrefix"],
                  this.detail["nameSuffix"]
                );
        }

        // Format start time
        const startTime = this.formatTime(
          this.detail["app_start_hh"],
          this.detail["app_start_mm"],
          this.detail["app_start_tt"]
        );

        // Format end time
        const endTime = this.formatTime(
          this.detail["app_end_hh"],
          this.detail["app_end_mm"],
          this.detail["app_end_tt"]
        );

        // Beautify date for user
        const dateBeautified = this.beautifyDate(this.detail["app_date"]);

        // Timelist for showing in which time slot the appointment is in
        const timeList = [];
        this.getTimeList(
          this.detail["app_start_hh"],
          this.detail["app_start_tt"],
          timeList
        );
        this.getTimeList(
          this.detail["app_end_hh"],
          this.detail["app_end_tt"],
          timeList,
          true
        );

        // Check if there are any notes, If any notes are set
        const notes =
          this.detail.notes == null
            ? "No notes"
            : this.detail.notes
                .replace(new RegExp("<script>", "gi"), "&lt;script&gt;")
                .replace(new RegExp("<//script>", "gi"), "&lt;/script&gt;")
                .replace(/(<[^>]+) style=".*?"/gi, "$1")
                .replace(/(<[^>]+) width=".*?"/gi, "$1")
                .replace(/(<[^>]+) height=".*?"/gi, "$1")
                .replace(/(<[^>]+) dir=".*?"/gi, "$1")
                .replace(/(<[^>]+) colspan=".*?"/gi, "$1")
                .replace(/(<[^>]+) rowspan=".*?"/gi, "$1")
                .replace(/(<[^>]+) border=".*?"/gi, "$1")
                .replace(/(<[^>]+) cellspacing=".*?"/gi, "$1")
                .replace(/(<[^>]+) cellpadding=".*?"/gi, "$1")
                .replace(/(<[^>]+) nowrap=".*?"/gi, "$1")
                .replace(/(<[^>]+) bgcolor=".*?"/gi, "$1")
                .replace(/(<[^>]+) rows=".*?"/gi, "$1")
                .replace(/(<[^>]+) cols=".*?"/gi, "$1");

        // Specify if appointment is a repeat appointment
        const repeat =
          this.detail.repeats === 1
            ? "This is a repeating appointment."
            : "This is not a repeating appointment.";

        const editable =
          this.detail.repeats === 0 &&
          this.detail.otherevent_type === 0 &&
          this.detail.client_id === 0 &&
          this.detail.otherevent_id === 0;

        return {
          id: this.detail.id,
          title,
          startTime,
          endTime,
          dateBeautified,
          timeList,
          notes,
          repeat,
          editable,
          connectCode: this.detail.connectcode,
          secure_video_session_id: this.detail.secure_video_session_id,
          isConnect: this.detail.is_connect,
          isVideo: this.detail.is_video,
          hashedPassCode: this.detail.hashed_pass_code,
          clientConnectcode: this.detail.clientConnectcode
        };
      } else {
        return false;
      }
    }
  },
  methods: {
    ...mapActions({
      getAppointmentById: "getAppointmentById",
      startVideoSession: "startVideoSession"
    }),
    ...mapMutations({
      setLoadingAppointmentDetails: "setLoadingAppointmentDetails"
    }),
    /**
     * Method for showing popop
     */
    showThePopup() {
      this.showPopup = true;
    },
    /**
     * Method for hiding popup
     */
    hideThePopup() {
      this.showPopup = false;
    },
    /**
     * Join a connect session for host
     */
    startConnectSession(sessionId, hashedPassCode) {
      var url = window.open(
        `${process.env.VUE_APP_CONNECT_BASE_URL}/${sessionId}/${hashedPassCode}?sessionHash=${JSON.parse(window.sessionStorage.getItem("auth")).token}`,
        "_blank"
      );
      if (!url || url.closed || typeof url.closed == "undefined") {
        this.$store.dispatch("globalMessagePopup", ERROR_MESSSAGE.popUpBlocker);
      }
    },
    /**
     * Join video session
     */
    startVideoSessionPortal(connectCode) {
      var url = window.open(
        `https://${this.baseSecureVideoUrl}.securevideo.com/Pass/Join/${connectCode}`,
        "_blank"
      );
      if (!url || url.closed || typeof url.closed == "undefined") {
        this.$store.dispatch("globalMessagePopup", ERROR_MESSSAGE.popUpBlocker);
      }
    },

    /**
     * Join Connect Session
     */
    startConnectSessionPortal(connectCode) {
      var url = window.open(
        `${process.env.VUE_APP_CONNECT_BASE_URL}/Join/${connectCode}?sessionHash=${JSON.parse(window.sessionStorage.getItem("auth")).token}`,
        "_blank"
      );
      if (!url || url.closed || typeof url.closed == "undefined") {
        this.$store.dispatch("globalMessagePopup", ERROR_MESSSAGE.popUpBlocker);
      }
    }
  },
  components: {
    SectionVue,
    LoaderVue
  },
  async created() {
    const id = !isNaN(this.$route.params.id)
      ? parseInt(this.$route.params.id)
      : false;

    if (id) {
      // Check if the appointment id had already been fetched from the server.
      // If not, fetch it from the server
      if (this.getQueriedId.indexOf(id) === -1) {
        // Start loader
        this.setLoadingAppointmentDetails(true);

        //Fetch the appointment
        await this.getAppointmentById(id);

        // Stop Loader
        this.setLoadingAppointmentDetails(false);
      }
    }
  }
};
</script>

<style scoped>
.strike {
  text-decoration: line-through;
}
.loader-container-appointmentpage {
  width: 100%;
  position: fixed;
  top: 45%;
  left: 45%;
  transform: translateY(-50px);
}
.loader-container-appointmentpage .loader {
  border: 5px solid #fff;
  border-top: 5px solid #c9ae7e;
  width: 25px;
  height: 25px;
}
section.edit-appoitntment {
  margin-top: 128px !important;
}
/* .event-wrapper {
  padding-left:0px;
}
.event-wrapper .heading-with-edit, .event-wrapper .event-subdetails-wrapper {
  padding-left:10px;
} */

.heading-with-edit {
  display: flex;
}

.heading-with-edit h3 {
  width: 50%;
  text-overflow: ellipsis!important;
  overflow: hidden!important;
  white-space: nowrap!important;
}

.have-event span {
  width: calc(100% - 50px);
  text-overflow: ellipsis !important;
  overflow: hidden !important;
  white-space: nowrap !important;
}

.content-wrapper {
  padding-left: 40px;
  box-sizing: border-box;
}

.header-btn {
  width: 50%;
}

.video-session-button {
  background-color: #e56700;
  color: white;
  border: none;
  outline: none;
  padding: 5px;
  /* margin-left: 20px; */
  margin-top: 5px;
  border-radius: 10px;
  font-weight: bold;
  height: 25px;
  float: right;
  margin-right: 10px;
}

.video-session-button:active {
  background-color: #fb5e00;
}
</style>
